import { render, staticRenderFns } from "./RentalcompanyInfo.vue?vue&type=template&id=5280db54&scoped=true"
import script from "./RentalcompanyInfo.vue?vue&type=script&lang=js"
export * from "./RentalcompanyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280db54",
  null
  
)

export default component.exports